export default {
  eyebrow: 'Portal do parceiro',
  title: 'Calculadora da taxa de serviço',
  description: 'Estime a receita da taxa de serviço gerada nos restaurantes da sua conta de parceiro.',
  toasts: {
    load_error: 'Não foi possível carregar as suas definições de taxa de serviço.',
  },
};
